import $ from 'jquery';

const Menu = () => {
  $(document).ready(function () {

    const $header = $('.site-header');

    // --- Scroll shadow ---
    $(window).on('scroll', function () {
      $header.toggleClass('scrolled', $(this).scrollTop() > 10);
    });

    // --- Function to sync desktop submenu background height ---
    function syncBackgroundHeight() {
      const $activeSubmenu = $('.submenu.show');
      const $background = $('.submenu-background');

      if ($activeSubmenu.length > 0) {
        // Level-2 container inside this submenu
        const $level2 = $activeSubmenu.find('.submenu__container.level-2').first();
        const level2Height = $level2.outerHeight() || 0;

        // Find the active sub-submenu link **inside this submenu only**
        const $activeLink = $activeSubmenu.find('.submenu__link.has-sub-submenu.active').first();
        let level3Height = 0;

        if ($activeLink.length) {
          const submenuId = $activeLink.data('submenu-id');
          const $level3 = $activeSubmenu.find(`.sub-submenu-group[data-submenu-id="${submenuId}"]`);
          if ($level3.length) {
            level3Height = $level3.outerHeight() || 0;
          }
        }

        $background.css('height', level2Height + level3Height + 'px').addClass('show');
      } else {
        $background.css('height', '0').removeClass('show');
      }
    }

    // --- Toggle sub-submenu (shared function for desktop & mobile) ---
    function toggleSubSubmenu($trigger, isMobile = false) {
      const $group = isMobile ? $trigger.closest('.mobile-submenu__group') :
        $(`.sub-submenu-group[data-submenu-id="${$trigger.data('submenu-id')}"]`);
      // const $submenu = isMobile ? $group.find('.mobile-sub-submenu') : null;

      // Close other sub-submenus in the same level
      if (isMobile) {
        $group.siblings('.mobile-submenu__group.has-sub-submenu').removeClass('open');
      } else {
        // Desktop: remove active from all other sub-submenu links and close groups
        $('.submenu__link.has-sub-submenu').not($trigger).removeClass('active');
        $('.sub-submenu-group').not($group).removeClass('active');
      }

      // Toggle current group
      $group.toggleClass('active');
      // if (isMobile && $submenu) {
      //   $submenu.stop(true, true).slideToggle(200);
      // }

      // Toggle active class on trigger
      $trigger.toggleClass('active');

      // Recalculate desktop background
      syncBackgroundHeight();
    }

    // --- Desktop top-level menu ---
    $('.nav-item.has-dropdown .nav-link').on('click', function (e) {
      e.preventDefault();
      const $this = $(this);
      const $item = $this.closest('.nav-item');
      const $submenu = $item.find('.submenu');

      if ($(e.target).hasClass('nav-link__text') && $this.attr('href') !== '#') {
        window.location.href = $this.attr('href');
        return;
      }

      const isActive = $this.hasClass('active');

      // Close all other dropdowns
      $('.nav-link').removeClass('active');
      $('.submenu').removeClass('show');

      if (!isActive) {
        $this.addClass('active');
        $submenu.addClass('show');
      }

      syncBackgroundHeight();
    });

    // --- Desktop sub-submenu click ---
    $('.submenu__link.has-sub-submenu').on('click', function (e) {
      e.preventDefault();
      toggleSubSubmenu($(this), false);
    });

    // --- Mobile Menu Toggle ---
    $('#mobile-menu-toggle').on('click', function () {
      $(this).toggleClass('active');
      $('#mobile-menu').toggleClass('open');
    });

    // --- Mobile Level 1 toggle ---
    $('.mobile-menu__item.has-dropdown > .mobile-menu__link').on('click', function (e) {
      e.preventDefault();
      const $this = $(this);
      const $item = $this.closest('.mobile-menu__item');
      const $submenu = $item.find('.mobile-submenu').first();

      if ($submenu.length) {
        // Close other top-level submenus
        $('.mobile-menu__item').not($item).removeClass('active');
        $('.mobile-menu__link').not($this).removeClass('active');

        $item.toggleClass('active');
        $this.toggleClass('active');
      }
    });

    // --- Mobile Level 2 sub-submenu toggle ---
    $('.mobile-submenu__group.has-sub-submenu > .mobile-submenu__link').on('click', function (e) {
      e.preventDefault();
      toggleSubSubmenu($(this), true);
    });

    // --- Click outside ---
    $(document).on('click', function (e) {
      if (!$(e.target).closest('.nav-item, .submenu').length) {
        $('.nav-link').removeClass('active');
        $('.submenu').removeClass('show');
        syncBackgroundHeight();
      }

      if (!$(e.target).closest('.mobile-menu, #mobile-menu-toggle').length) {
        $('#mobile-menu').removeClass('open');
        $('#mobile-menu-toggle').removeClass('active');
      }
    });

    // --- Window resize ---
    let resizeTimer;
    $(window).on('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if ($('.submenu.show').length > 0) {
          syncBackgroundHeight();
        }
        if ($(window).width() >= 1024) {
          $('#mobile-menu').removeClass('open');
          $('#mobile-menu-toggle').removeClass('active');
        }
      }, 250);
    });

    // --- Initial setup ---
    syncBackgroundHeight();
  });
};

export default Menu;
